import { Component, Inject, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { ProcedureListProvider } from "../../../../../../../../shared/cw-backend/providers/accreditation/procedure/procedure-list.provider";
import { ParticipationEditProvider } from "../../../../../../../../shared/cw-backend/providers/organizational/participation/participation-edit.provider";
import {
    FormBuilder,
    FormControl,
    FormGroup,
    Validators,
} from "@angular/forms";
import {
    CwUtils,
    PageOptions,
} from "../../../../../../../../shared/cw-utils/cw-utils.service";
import { Subject, debounceTime, distinctUntilChanged, takeUntil } from "rxjs";
import {
    Insurance,
    OrderItemThirdPartyTO,
    Participation,
    ThirdPartyTO,
} from "../../../../../../../../shared/cw-backend/models/backend-definitions.module";
import { ThirdPartyListProvider } from "../../../../../../../../shared/cw-backend/providers/organizational/thirdparty/thirdparty-list.provider";
import { ThirdPartyEditProvider } from "../../../../../../../../shared/cw-backend/providers/organizational/thirdparty/thirdparty-edit.provider";

@Component({
    selector: "app-thirdparty-order-item-edit",
    templateUrl: "./thirdparty-order-item-edit.component.html",
    styleUrls: ["./thirdparty-order-item-edit.component.scss"],
})
export class ThirdpartyOrderItemEditComponent implements OnInit {
    loading: boolean = false;
    thirdPartyOrderItemForm: FormGroup;
    thirdPartyList: ThirdPartyTO[];
    orderItemThirdPartyList: OrderItemThirdPartyTO[];
    participationTypeList: Participation[];
    thirdPartyPageOptions: PageOptions;
    displayedColumns = [
        "thirdparty",
        "participationType",
        "participationValue",
        "value",
        "buttons",
    ];
    orderItemThirdPartyPageOptions: PageOptions;
    insuranceList: Insurance[];
    type: string = "1";
    private _unsubscribeAll: Subject<any>;
    buttonDisabled: boolean = false;

    //tabela
    totalElements = 0;
    pagina = 0;
    tamanho = 0;
    pageSize = 10;

    constructor(
        public _matDialogRef: MatDialogRef<ThirdpartyOrderItemEditComponent>,
        private thirdPartyListProvider: ThirdPartyListProvider,
        private thirdPartyEditProvider: ThirdPartyEditProvider,
        private participationEditProvider: ParticipationEditProvider,
        private _formBuilder: FormBuilder,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {
        this._unsubscribeAll = new Subject();
        this.thirdPartyPageOptions = new PageOptions();
        this.orderItemThirdPartyPageOptions = new PageOptions();
    }

    ngOnInit() {
        this.thirdPartyOrderItemForm = this.createForm();
        this.getThirdPartyList();
        this.filterThirdParty();
        this.getOrderItemThirdPartyList();

        // if (this.data.orderStatus == "Fechada") {
        //     this.thirdPartyOrderItemForm.disable();
        //     this.buttonDisabled = true;
        // }   
        
        // console.log(this.data);
    }

    createForm(): FormGroup {
        return this._formBuilder.group({
            id: [],
            orderItem: new FormControl(CwUtils.extractId(this.data.orderItem)),
            thirdParty: new FormControl(),
            participationType: new FormControl("1"),
            participationValue: new FormControl(),
            value: new FormControl(),
            participationAmount: new FormControl(),
            participationValueFilm: new FormControl(),
        });
    }

    checkType() {
        let type = this.thirdPartyOrderItemForm.get("participationType");
        let value = type?.value;

        if (value == "1") {
            this.thirdPartyOrderItemForm.controls["participationType"].setValue(
                "2"
            );
            this.type = "2";
        } else {
            this.thirdPartyOrderItemForm.controls["participationType"].setValue(
                "1"
            );
            this.type = "1";
        }
    }

    displayFn(obj?: any): string | undefined {
        if (obj) {
            return obj.name;
        }
        return null;
    }

    displayThirdPartyFn(obj?: any): string | undefined {
        if (obj && obj.personName) {
            return obj.personName;
        } else if (obj && obj.professionalName) {
            return obj.professionalName;
        } else if (obj && obj.performerName) {
            return obj.performerName;
        } else if (obj && obj.firmName) {
            return obj.firmName;
        }
        return null;
    }

    getThirdPartyList() {
        this.thirdPartyListProvider
            .getPageSimple(this.thirdPartyPageOptions)
            .then((res) => {
                this.thirdPartyList = res.body.content;
            });
    }

    getOrderItemThirdPartyList(event?, type?) {
        switch (type) {
            case "short":
                this.thirdPartyPageOptions.fieldSort = event.active;
                this.thirdPartyPageOptions.sortDirection = event.direction;
                break;
            case "page":
                this.thirdPartyPageOptions.page = event.pageIndex;
                this.thirdPartyPageOptions.sizePage = event.pageSize;
                break;

            default:
                this.thirdPartyPageOptions.page = 0;
                this.thirdPartyPageOptions.sizePage = 10;
                break;
        }

        this.thirdPartyListProvider
            .getPageOrderItemThirdParty(
                this.thirdPartyPageOptions,
                this.data.orderItem.id
            )
            .then((res) => {
                this.orderItemThirdPartyList = res.body.content;
                this.totalElements = res.body.totalElements;
                this.pagina = res.body.number;
                this.pageSize = res.body.size;
            });
    }

    getThirdPartyParticipation(thirdPartyId: number) {
        this.thirdPartyListProvider
            .getThirdPartyParticipation(
                thirdPartyId,
                this.data.orderItem.procedure.id
            )
            .then((res) => {
                let thirdPartyParticipation = res.body.data;

                if (thirdPartyParticipation != null) {
                    this.thirdPartyOrderItemForm.controls[
                        "participationValue"
                    ].setValue(thirdPartyParticipation.participationValue);
                    this.thirdPartyOrderItemForm.controls[
                        "participationType"
                    ].setValue(thirdPartyParticipation.participationType);
                    this.type = thirdPartyParticipation.participationType;
                } else {
                    this.thirdPartyOrderItemForm.controls[
                        "participationValue"
                    ].setValue(null);
                    this.thirdPartyOrderItemForm.controls[
                        "participationType"
                    ].setValue(null);
                    this.type = "1";
                }
            });
    }

    filterThirdParty() {
        this.thirdPartyOrderItemForm.controls["thirdParty"].valueChanges
            .pipe(
                takeUntil(this._unsubscribeAll),
                debounceTime(500),
                distinctUntilChanged()
            )
            .subscribe({
                next: (res) => {
                    let filter = "";
                    if (typeof res === "string") {
                        filter = res;
                        this.thirdPartyPageOptions.argument = res;
                        this.getThirdPartyList();
                    } else if (res?.id) {
                        this.getThirdPartyParticipation(res.id);
                    }
                },
            });
    }

    confirm() {
        let data = this.thirdPartyOrderItemForm.getRawValue();

        data.thirdParty = CwUtils.extractId(data.thirdParty);


        this.thirdPartyEditProvider
            .insertThirdPartyOrderItem(data)
            .then((res) => {
                this.getOrderItemThirdPartyList();
                this.thirdPartyOrderItemForm.controls['thirdParty'].setValue(null);
            });
    }

    dimiss() {
        this._matDialogRef.close();
    }

    delete(orderItemThirdParty: any) {
        this.thirdPartyEditProvider
            .deleteThirdPartyOrderItem(orderItemThirdParty)
            .then((res) => {
                this.getOrderItemThirdPartyList();
            });
    }
}
